const entries = [
  { icon: "ri-smartphone-line", label: "iOS / Android 下载" },
  { icon: "ri-mail-send-line", label: "订阅每周速览" },
  { icon: "ri-wechat-2-line", label: "加入吃瓜群" },
  { icon: "ri-rss-line", label: "RSS 订阅" },
];

export default function Promo() {
  return (
    <section className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
      <div className="relative overflow-hidden rounded-2xl bg-primary-600 px-6 py-12 md:px-12 md:py-16">
        <span className="pointer-events-none absolute -right-6 -top-14 select-none font-heading text-[15rem] font-black leading-none text-background-50/10">瓜</span>
        <i className="ri-focus-3-line pointer-events-none absolute -bottom-10 left-10 h-40 w-40 text-background-50/10" />

        <div className="relative mx-auto max-w-3xl text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50">
            <i className="ri-rocket-2-line h-4 w-4" />
            事件一出，第一时间跟上
          </p>
          <h2 className="mt-5 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            别等全网都在聊，
            <br className="hidden sm:block" />
            才想起来看全貌
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-background-50/85 md:text-base">
            更新的时间线、深扒的内幕、没人注意的关键节点——挑一个入口，我们把完整来龙去脉直接送到你面前。
          </p>

          <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#zhuanti"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition hover:bg-background-100"
            >
              <i className="ri-download-2-line h-4 w-4" />
              立即下载 App
            </a>
            <button
              type="button"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm text-background-50 transition hover:border-background-50 hover:bg-background-50/10"
            >
              <i className="ri-arrow-right-line h-4 w-4" />
              先收藏这篇
            </button>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-7 gap-y-4">
            {entries.map((e) => (
              <button
                key={e.label}
                type="button"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-xs text-background-50/90 transition hover:text-background-50"
              >
                <i className={`${e.icon} h-4 w-4`} />
                {e.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}